import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import CountrySelectionPage from "./countrySelectionPage";
import Nav from "./nav";
import Thailand from "./countryPages/Thailand";
import Bali from "./countryPages/Bali";
import Vietnam from "./countryPages/Vietnam";
import Laos from "./countryPages/Laos";
import Calendar from "./calendar";
import Test from "./Test";
import Hungary from "./countryPages/Hungary";
import Germany from "./countryPages/Germany";

export default function() {
  return (
    <Router>
      <Nav />
      <Switch>
        <Route path="/map/thailand" component={Thailand} />
        <Route path="/map/bali" component={Bali} />
        <Route path="/map/vietnam" component={Vietnam} />
        <Route path="/map/laos" component={Laos} />
        <Route path="/map/hungary" component={Hungary} />
        <Route path="/map/germany" component={Germany} />
        <Route path="/calendar" component={Calendar} />
        <Route path="/test" component={Test} />
        <Route path="/" component={CountrySelectionPage} />
      </Switch>
    </Router>
  );
}
